import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ElasticQuery } from 'app/interfaces/elastic-query.model';
import { QueryType } from 'app/enums/query-type.enum';

@Component({
  selector: 'app-aggregation-range',
  templateUrl: './aggregation-range.component.html',
  styleUrls: ['./aggregation-range.component.scss']
})
export class AggregationRangeComponent implements OnInit {
  @Input() aggregation: any;
  @Output() onChange: EventEmitter<ElasticQuery> = new EventEmitter<ElasticQuery>();
  @Input() expanded = true;
  selectedVal: any = '';
  constructor() { }

  ngOnInit() {
    if (this.aggregation.selectedValues) {
      const matchedVal = this.aggregation.Items.filter(a => {
        return a.From === (this.aggregation.selectedValues[0] || null) && a.To === (this.aggregation.selectedValues[1] || null)
      });
      if (matchedVal.length > 0) {
        this.selectedVal = matchedVal[0];
        this.expanded = false;
      }
    }
  }

  valueChanged(e) {
    this.onChange.emit({
      Field: this.aggregation.Meta.title,
      Type: QueryType.DROPDOWN,
      Values: [this.selectedVal.From || 0, this.selectedVal.To || 0]
    });
  }
}
